export const NewOrderType = {
  install: "install",
  rate: "rate",
  review: "review-manual",
  install_bp: "install_bp",
  install_with_views: "install_with_views",
};

export type TNewOrderType = (typeof NewOrderType)[keyof typeof NewOrderType];
